import React from 'react';
import {useIntl} from 'react-intl';
import {currencyFormatter} from '@homeaway/hacommons-i18n';

export type Props = {
    minPrice: number;
    maxPrice: number;
    currency: string;
    isMax: boolean;
};

const FormattedCurrencyRange = ({
    minPrice,
    maxPrice,
    currency,
    isMax,
}: Props) => {
    const {locale} = useIntl();
    const minPriceFormatted = currencyFormatter.formatNumber({
        value: minPrice,
        currencyCode: currency,
        locale,
    });
    const maxPriceFormatted = currencyFormatter.formatNumber({
        value: maxPrice,
        currencyCode: currency,
        locale,
    });

    return (
        <span>
            {minPriceFormatted}
            {' - '}
            {maxPriceFormatted}
            {isMax && '+'}
        </span>
    );
};

export default FormattedCurrencyRange;
